import { Intl } from "@ies/starling_intl";
class I18n extends Intl {
  // @ts-expect-error
  init(...args) {
    const injectedOpts = this._injector(this);
    const lng = args[0];
    let initOpts = args[1];
    const plugins = args[2] || [];
    if (initOpts) {
      var _initOpts;
      (_initOpts = initOpts).lng ?? (_initOpts.lng = lng);
    } else if (typeof lng === "string") {
      initOpts = {
        lng
      };
    } else {
      initOpts = lng;
    }
    plugins.forEach((p) => this.use(p));
    const solutionOpts = initOpts.solution ?? injectedOpts.solution;
    if (!solutionOpts)
      throw Error("[i18n error] solution config must injected");
    const opts = {
      ...this._extractOptsFromSolutionConfig(solutionOpts),
      ...injectedOpts,
      fallbackLng: "en",
      load: "currentOnly",
      ...initOpts
    };
    if (!initOpts.defaultNS) {
      opts.defaultNS = opts.ns[0];
    }
    return this._doInit(opts);
  }
  // @ts-expect-error
  use(plugin) {
    if (plugin.name === "react-plugin") {
      plugin.init(this);
    }
    super.use(plugin);
    return this;
  }
  _extractOptsFromSolutionConfig(config) {
    const { namespaces } = config;
    const ns = namespaces.map(({ spaceName }) => spaceName);
    let backend = {};
    if (config.mode === "extract") {
      backend = {
        loadPath: `${config.cdn}/i18n/${config.version}/{{ns}}/{{lng}}.json`,
        crossDomain: true
      };
    } else if (typeof __I18N_USE_API__ === "undefined" || !__I18N_USE_API__) {
      backend = {
        loadPath: ([lng], [ns2]) => {
          const { projectId, spaceId } = config.namespaces.find((el) => el.spaceName === ns2);
          return `${config.cdn}/i18n/${projectId}__${spaceId}/${lng}.json`;
        },
        crossDomain: true
      };
    }
    return {
      ns,
      backend
    };
  }
  _setInitOptsInjector(injector) {
    this._injector = injector;
  }
  _doInit(initOpts) {
    return super.init(initOpts).then((res) => {
      const maybeError = res.err;
      if (!maybeError)
        return {};
      const err = "err" in maybeError ? maybeError.err : maybeError;
      const errs = Array.isArray(err) ? err : [
        err
      ];
      errs.forEach((e) => console.error(`[i18n error] ${e}`));
      return {
        errs
      };
    });
  }
  /**
  * @deprecated use `cloneInstance` instead.
  */
  clone() {
    return this.cloneInstance();
  }
  // @ts-expect-error
  cloneInstance() {
    const instance = Object.create(I18n.prototype);
    const proto = super.cloneInstance();
    instance.i18nInstance = proto.i18nInstance;
    instance.plugins = proto.plugins;
    instance.ignoreWarning = proto.ignoreWarning;
    instance.t = I18n.prototype.t.bind(proto);
    instance._setInitOptsInjector(this._injector);
    return instance;
  }
  changeLanguage(lng) {
    return new Promise((resolve) => {
      this.setLang(lng, (err) => {
        const maybeError = err;
        if (!maybeError)
          return {};
        const error = "err" in maybeError ? maybeError.err : maybeError;
        const errs = Array.isArray(error) ? error : [
          error
        ];
        errs.forEach((e) => console.error(`[i18n error] ${e}`));
        resolve({
          errs
        });
      });
    });
  }
  /** @internal */
  static _create(defaultPlugin) {
    const i18n = new I18n();
    if (defaultPlugin) {
      i18n.use(defaultPlugin);
    }
    return i18n;
  }
  constructor() {
    super();
    this._injector = () => ({});
    this.t = this.t.bind(this);
  }
}
export {
  I18n
};

//# sourceMappingURL=index.js.map